export const LangOptions = [
  "GERMAN",
  "ENGLISH",
  "MONGOLIAN",
  "ROMANIAN",
  "GEORGIAN",
  "PORTUGUESE",
  "VIETNAMESE",
  "BASQUE",
  "MALTESE",
  "JAPANESE",
  "NORWEGIAN",
  "BULGARIAN",
  "CZECH",
  "ITALIAN",
  "FRENCH",
  "NEPALI",
  "SLOVENIAN",
  "CROATIAN",
  "SLOVAK",
  "SPANISH",
  "HUNGARIAN",
  "UZBEK",
  "KHMER",
  "LITHUANIAN",
  "HINDI",
  "SERBIAN",
  "BELARUSIAN",
  "SINHALA",
  "DANISH",
  "FINNISH",
  "ICELANDIC",
  "PERSIAN",
  "ESTONIAN",
  "BENGALI",
  "BURMESE",
  "MALAY",
  "GREEK",
  "THAI",
  "HEBREW",
  "DUTCH",
  "MACEDONIAN",
  "KAZAKH",
  "RUSSIAN",
  "TURKISH",
  "ARMENIAN",
  "ARABIC",
  "LATVIAN",
  "CHINESE",
  "ALBANIAN",
  "AZERBAIJANI",
  "BOSNIAN",
  "KOREAN",
  "SWEDISH",
  "POLISH",
]